/** @file The picked facet entry's own depth offset in zBias steps (CR-006, design 22.4). */
import type { ImpostorDrawable } from '@zilo/pose3d-format/types/drawable';

/**
 * `drawable.facets[entry].depth.offset`, 0 when absent. Added on top of the pick's `depthOffset`, which carries only
 * `depth.side` / `depth.back` by class (the facet contract), so the offset applies in every sector.
 */
export function entryDepthOffsetOf(drawable: ImpostorDrawable, entry: number): number {
  return drawable.facets[entry]?.depth?.offset ?? 0;
}
